<template>
  <div class="accessories-tab">
    <v-layout justify-space-between mb-3>
      <h2>Filtrer</h2>
    </v-layout>
    <v-row class="filters-container" mb-8 wrap>
      <v-col cols="6">
        <v-select
          v-model="productModel"
          :items="productModelItems"
          label="Type"
          clearable
        ></v-select>
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="search"
          label="Recherche"
          append-icon="mdi-magnify"
          clearable
        ></v-text-field>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="filteredArticles"
      :search="search"
      fixed-header
      height="500"
      class="mb-6"
    >
      <template #top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Accessoires</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="700px" persistent>
            <template #activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Nouveau</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-validate="'required'"
                        data-vv-name="article_reference"
                        :error="errors.has('article_reference')"
                        v-model="editedItem.article_reference"
                        label="Référence"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row
                    v-for="(setting, index) in editedItem.setting_list"
                    :key="index"
                  >
                    <v-col cols="4">
                      <v-select
                        v-validate="'required'"
                        data-vv-name="`producy-model-${index}`"
                        :error="errors.has(`producy-model-${index}`)"
                        v-model="setting.product_model"
                        :items="productModelItems"
                        label="Type"
                      ></v-select>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model="setting.section"
                        label="Section"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-checkbox
                        v-model="setting.idc_entry"
                        label="Quantité"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="2">
                      <v-btn icon @click="removeSetting(index)">
                        <v-icon color="red">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-btn color="primary" @click="addSetting" text x-small
                        >Ajouter type</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Annuler</v-btn>
                <v-btn color="blue darken-1" text @click="save"
                  >Enregistrer</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <!-- Amount HT -->
      <template #item.amount_ht="{ value }">
        {{ value | currency }}
      </template>

      <!-- Soft delete -->
      <template #item.idc_soft_delete="{ value }">
        <v-icon v-if="value">mdi-check</v-icon>
      </template>

      <!-- Actions -->
      <template #item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import ArticlesRepo from "@/repositories/settings/articles";
  import { productsObject } from "@/utils/products";

  export default {
    name: "AccessoriesTab",
    data() {
      return {
        headers: [
          {
            text: "Référence",
            align: "left",
            value: "article_reference"
          },

          // A pluger
          // {
          //   text: "Désignation",
          //   align: "left",
          //   value: "label"
          // },

          // A pluger
          {
            text: "Montant HT",
            align: "left",
            value: "amount_ht"
          },

          // A pluger
          {
            text: "Historisé",
            align: "left",
            value: "idc_soft_delete"
          },

          {
            text: "Actions",
            value: "action",
            sortable: false
          }
        ],

        productsObject: productsObject,

        articles: [],

        // Filters
        search: "",
        productModel: "",

        productModelItems: [
          { text: "Minerve", value: "NECK_BRACE" },
          { text: "Siège moulé", value: "MOLDED_SEAT" },
          { text: "OTN", value: "OTN" },
          { text: "Verticalisateur", value: "LIFT" },
          { text: "Retouche/Réparation", value: "RETOUCHING_REPAIR" },
          { text: "Selle", value: "SEAT" },
          { text: "Selle de positionnement", value: "POSITIONING_SEAT" },
          { text: "Orthèse Sup", value: "UPPER_LIMB_ORTHOSIS" },
          { text: "Orthèse Inf", value: "LOWER_LIMB_ORTHOSIS" },
          { text: "Corset", value: "CORSET" }
        ],

        selectedProductsModel: [],

        defaultItem: {
          article_reference: null,
          setting_list: []
        },

        dialog: false,
        editedId: -1,
        editedItem: {
          article_reference: null,
          setting_list: []
        }
      };
    },
    computed: {
      formTitle() {
        return this.editedId === -1
          ? "Ajouter un accessoire"
          : "Modifier un accessoire";
      },

      filteredArticles() {
        let articles = this.articles;

        if (this.productModel && this.productModel !== "") {
          articles = articles.filter(article => {
            const foundProductModel = article.setting_list.findIndex(
              setting => {
                return setting.product_model === this.productModel;
              }
            );
            return foundProductModel !== -1;
          });
        }

        return articles;
      }
    },

    methods: {
      removeSetting(index) {
        this.editedItem.setting_list.splice(index, 1);
      },

      addSetting() {
        this.editedItem.setting_list.push({
          product_model: null,
          idc_entry: false,
          section: null
        });
      },

      editItem(item) {
        this.editedId = item.article_id;
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      /**
       * Delete a device
       */
      async deleteItem(item) {
        confirm("Voulez-vous supprimer cet accessoire?") &&
          (await ArticlesRepo.deleteArticle(item.article_id));

        this.getArticles();
      },

      /**
       * Save article on server
       */
      async save() {
        // Check if form is valid
        const isValid = await this.$validator.validateAll();

        if (!isValid) {
          return;
        }

        try {
          if (this.editedId > -1) {
            await ArticlesRepo.updateArticle(this.editedId, this.editedItem);
          } else {
            await ArticlesRepo.create(this.editedItem);
          }
        } catch (error) {
          if (
            error &&
            error.response.data.error == "ERR_LOMACO_GET_ARTICLE_BY_REFERENCE"
          ) {
            alert("Accessoire introuvable (Lomaco)");
          }
        }

        this.getArticles();
        this.close();
      },

      /**
       * Close dialog and reset edited item
       */
      close() {
        this.dialog = false;
        this.errors.clear();
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedId = -1;
        }, 300);
      },

      /**
       * Get all articles
       */
      async getArticles() {
        try {
          const { data } = await ArticlesRepo.get();
          this.articles = data;
        } catch (error) {
          alert(error);
        }
      }
    },
    created() {
      this.getArticles();
    }
  };
</script>

<style lang="scss">
  .accessories-tab {
    .v-data-table__wrapper {
      height: 470px !important;
    }
    .total {
      p {
        text-align: right;
        color: #006064;
        font-weight: bold;
        font-size: 15px !important;
      }
    }
    .v-data-table table tr td {
      height: auto !important;
    }
    .v-data-table table tbody td .v-input .v-input__control .v-input__slot {
      height: auto !important;
    }
  }
</style>
